import { render, staticRenderFns } from "./OrganizationUserGuard.vue?vue&type=template&id=90f3902a&"
import script from "./OrganizationUserGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports